import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { RotaBadge } from "@/pages/entregas/entregasHelpers";

// Rotas ATIVAS que contêm o bairro — mesma regra do formulário individual (Iter 98).
export const rotasDoBairro = (rotas, bairroId) =>
  bairroId ? (rotas || []).filter((r) => r.ativa !== false && (r.bairro_ids || []).includes(bairroId)) : [];

/**
 * Coluna "Rota" da linha do lote: 1 rota → badge automática (sem campo);
 * 2+ rotas → select para escolher; 0 → "Sem rota".
 */
export function LoteRotaCell({ row, index, rotas, onChange }) {
  const cands = rotasDoBairro(rotas, row.bairro_id);
  if (!row.bairro_id) return <span className="text-slate-300 text-xs" data-testid={`lote-rota-${index}`}>—</span>;
  if (cands.length === 0) return <span className="text-slate-400 text-xs italic" data-testid={`lote-rota-${index}`} data-rota-mode="none">Sem rota</span>;
  if (cands.length === 1) {
    return (
      <div className="flex flex-col gap-0.5" data-testid={`lote-rota-${index}`} data-rota-mode="auto">
        <RotaBadge rota={cands[0]} testId={`lote-rota-badge-${index}`} />
        <span className="text-[10px] text-emerald-600">automática</span>
      </div>
    );
  }
  const chosen = cands.find((r) => r.id === row.rota_id);
  return (
    <div className="flex flex-col gap-1 min-w-[150px]" data-testid={`lote-rota-${index}`} data-rota-mode="choose">
      <Select value={row.rota_id || "__none__"} onValueChange={(v) => onChange(v === "__none__" ? "" : v)}>
        <SelectTrigger className={`h-9 text-sm ${chosen ? "" : "ring-2 ring-amber-400"}`} data-testid={`lote-rota-select-${index}`}>
          <SelectValue placeholder="Escolha a rota" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="__none__">Sem rota</SelectItem>
          {cands.map((r) => (
            <SelectItem key={r.id} value={r.id} data-testid={`lote-rota-opt-${index}-${r.id}`}>
              <span className="inline-flex items-center gap-2"><span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: r.cor }} />{r.nome}</span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {chosen
        ? <RotaBadge rota={chosen} testId={`lote-rota-badge-${index}`} />
        : <span className="text-[10px] text-amber-700">bairro em {cands.length} rotas</span>}
    </div>
  );
}
